<template>
  <div>

      <ul class="chat-sidebar-list">
            <li v-for="(contact,index) in contactList" :key="index">
                <a :class="[{ 'router-link-exact-active router-link-active' : contact.id == selected.id },{ 'unreadMsg' : contact.id == 1}]" >
                     <base-dropdown class="chatProfileImg chatProfileSetting">
                        <div slot="title">
                            <img :src="require(`@/assets/images/${contact.img}`)" alt class="icon" />
                            <span v-if="contact.id == 1">2</span>
                        </div>

                        <template>
                            <a href="#">
                               Navigate
                            </a>
                            <a href="#">
                               Block
                            </a>
                            <a href="#">
                               Block & Report
                            </a>
                        </template>
                    </base-dropdown>
                    <div class="chatProfileDesc" @click="selectedContact(contact)">
                      <h3>{{contact.name}}</h3>
                      <p>Three Ways To Get Travel Disco...</p>
                      <span>11:23 am</span>
                    </div>
                </a>
            </li>
      </ul>

  </div>
</template>

<script>
  import { EventBus } from '../../main';
  export default {

      name: "direct-chat-list",
      props: ['windowSize'],

      data() {
          return {
            selected:'',
            userSelected:[],
            contactList:[
              {
                id:1,
                name:'Ricardo Lopez',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'chat-user1.png',
                messages:[
                    {
                      body: 'Become A Travel Pro In One Easy',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:00 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:1,
                      date: 'Tuesday, February 25, 2020 2:05 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                ]
              },
              {
                id:2,
                name:'Frederick Byrd',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'chat-user2.png',
                messages:[
                    {
                      body: 'Become A Travel Pro In One Easy',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:00 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:1,
                      date: 'Tuesday, February 25, 2020 2:05 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                ]
              },
              {
                id:3,
                name:'Hilda Hansen',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'chat-user3.png',
                messages:[
                    {
                      body: 'Become A Travel Pro In One Easy',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:00 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:1,
                      date: 'Tuesday, February 25, 2020 2:05 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                ]
              },
              {
                id:4,
                name:'Zikoranaudodimma Nkechi',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'chat-user4.png',
                messages:[
                    {
                      body: 'Become A Travel Pro In One Easy',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:00 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:1,
                      date: 'Tuesday, February 25, 2020 2:05 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                ]
              },
              {
                id:5,
                name:'Bithika Abhedananda',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'chat-user5.png',
                messages:[
                    {
                      body: 'Become A Travel Pro In One Easy',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:00 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:1,
                      date: 'Tuesday, February 25, 2020 2:05 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                ]
              },
              {
                id:6,
                name:'Donat Twerski',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'chat-user6.png',
                messages:[
                    {
                      body: 'Become A Travel Pro In One Easy',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:00 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:1,
                      date: 'Tuesday, February 25, 2020 2:05 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                ]
              },
              {
                id:7,
                name:'Ricardo Lopez',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'chat-user1.png',
                messages:[
                    {
                      body: 'Become A Travel Pro In One Easy',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:00 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:1,
                      date: 'Tuesday, February 25, 2020 2:05 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                ]
              },
              {
                id:8,
                name:'Ricardo Lopez',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'chat-user1.png',
                messages:[
                    {
                      body: 'Become A Travel Pro In One Easy',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:00 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:1,
                      date: 'Tuesday, February 25, 2020 2:05 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                    {
                      body: 'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
                      id:2,
                      date: 'Tuesday, February 25, 2020 2:10 AM'
                    },
                ]
              },
            ],

          }
      },

      methods: {
        profileImg(img){
          return '/img/'+img
        },

        selectedContact(data){
          this.selected=data;
          let url = this.$route.path;
          if(url=='/inbox' && this.windowSize>768){
            EventBus.$emit('message', data);
          } else {
            this.$router.push('/chat-details/'+data.id);
          }
        }

      },


  }
</script>
